<div class="dialog-content-wrapper fav-icon-dialog-wrapper min-w-3/4 md:min-w-80">
  <mat-toolbar class="mat-primary m-0">
    <mat-toolbar-row fxFlex fxLayout="row" fxLayoutAlign="space-between center" class="flex justify-between">
      <span class="title dialog-title text-xl text-black m-0">Set Favourite </span>
      <button mat-icon-button (click)="matDialogRef.close(['cancel',frmSetFavourite])" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>

  <div mat-dialog-content class="p-2 sm:p-3">
    <div class="p-2 m-0 scroll-fix-height" fusePerfectScrollbar>
      <form [formGroup]="frmSetFavourite" name="frmSetFavourite" class="event-form w-100-p" fxLayout="column" fxFlex>
        <div fxLayout="row wrap">
          @for (item of assignedCompanyList; track $index) {           
          <div fxFlex="50%" fxFlex.xs="100%">
            <div class="">
              @if(item.isFavourite){
              <mat-checkbox color="primary" (change)="onChangeCompany($event)" checked="true"
                [value]="item">{{item.companyName}}</mat-checkbox>
              }
              @if(!item.isFavourite){
              <mat-checkbox color="primary" (change)="onChangeCompany($event)"
                [value]="item">{{item.companyName}}</mat-checkbox>
              }
            </div>
          </div>
        }
        </div>
      </form>
    </div>
  </div>

  <div mat-dialog-actions class="m-0 pt-0 p-3 mat-action-fav flex justify-center gap-3" fxLayout="row" fxLayoutAlign="flex-end center">
    <button mat-raised-button class="save-button mat-primary shadow-none"
      (click)="matDialogRef.close(['submit',frmSetFavourite])">Submit</button>
    <button mat-button (click)="matDialogRef.close(['cancel',frmSetFavourite])" color="warn">Cancel</button>
  </div>
</div>